import React from "react";
import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";
import Visibility from "../utils/Visibility";
import BranchInfo from "./BranchInfo";
import SocialMedia from "./SocialMedia";
import BranchModel from "../../Models/BranchModel";
import { SheetContent } from "../ui/sheet";
import { indexStore } from "../../store/indexStore";
import { SettingsSocialMedia } from "../../Models/SettingsModel";

const Details = (props: {
  branch: BranchModel;
  social: SettingsSocialMedia[];
}) => {
  const { t } = useTranslation();

  // استخدام البيانات من props أولاً، وإذا لم تكن موجودة نستخدم store
  const { socialMedia: socialFromStore, branch: branchFromStore } = indexStore();
  const branch = props.branch || branchFromStore;
  const social = props.social || socialFromStore;

  return (
    <SheetContent
      hiddenCloseButton={true}
      side={"bottom"}
      className="flex flex-col border-t-2 border-primary/20 p-0 max-h-[80vh] overflow-hidden z-50 rounded-t-3xl"
    >
      {/* Header - Enhanced Design */}
      <div className="sticky top-0 z-10 px-6 pt-6 pb-4 border-b-2 border-primary/20 bg-gradient-to-br from-primary/10 via-primary/5 to-background shadow-sm">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-xl bg-primary/10 border border-primary/20">
            <Info className="w-5 h-5 md:w-6 md:h-6 text-primary" />
          </div>
          <h2 className="text-lg md:text-xl font-bold text-foreground">
            {t("gloabl.info")}
          </h2>
        </div>
      </div>

      {/* Content - Improved Spacing and Scroll */}
      <div className="flex-1 overflow-y-auto px-4 py-4 space-y-5 scrollbar-thin scrollbar-thumb-primary/20 scrollbar-track-transparent">
        {branch && Object.keys(branch).length > 0 && (
          <div className="opacity-0 animate-[fadeIn_0.3s_ease-out_0.1s_forwards]">
            <BranchInfo branch={branch} />
          </div>
        )}
        <Visibility visible={social && social.length !== 0}>
          <div className="opacity-0 animate-[fadeIn_0.3s_ease-out_0.2s_forwards]">
            <SocialMedia social={social} />
          </div>
        </Visibility>
      </div>
    </SheetContent>
  );
};

export default Details;
